import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ness-paged-loading-status',
  template: `<div><span class="spinner-border spinner-border-sm text-active" role="status"></span> Loading rows {{startRow}} thru {{endRow}}</div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PagedLoadingStatusComponent {
  @Input() set startRow(start: number) {
    this._startRow = start;
  }

  get startRow() {
    return this._startRow;
  }

  @Input() set endRow(end: number) {
    this._endRow = end;
  }

  get endRow() {
    return this._endRow;
  }

  @Input() set messageTemplate(template: string) {
    this._messageTemplate = template;
  }

  get messageTemplate() {
    return this._messageTemplate;
  }

  private _startRow: number;
  private _endRow: number;
  private _messageTemplate: string = `Loading...`;
} 
